export default __webpack_public_path__ + "img/a4ad472c4cc6dbdf62ed199ff27cd251.png";